/// <amd-module name="Artifacts/Package/containers/PackageDetailsContainer" />

import { PackageDetailsHub } from "Artifacts/Package/components/PackageDetailsHub";
import { PackageModule } from "Artifacts/Package/redux";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { connectDynamicModules } from "Artifacts/Root/redux";
import { feedHubRoute } from "Artifacts/Root/routing/Constants";
import { packageContainerName } from "Artifacts/Root/routing/Definitions";
import { IPackageDetailsContainerRouteParams } from "Artifacts/Root/routing/Types";
import * as React from "react";
import { connect } from "react-redux";
import { generatePath, useHistory } from "react-router-dom";
import { Components } from "VSS/Platform/Layout";

const PackageDetailsContainer: React.FC = () => {
  const { feed } = useFeed();
  const history = useHistory();

  return (
    <PackageDetailsHub
      onBackButton={() => history.push(generatePath(feedHubRoute, { feedIdentifier: feed?.name }))}
    />
  );
};

const ConnectedPackageDetailsContainer = connectDynamicModules(
  connect()(PackageDetailsContainer),
  PackageModule,
);

Components.add(packageContainerName, ConnectedPackageDetailsContainer);

export {
  ConnectedPackageDetailsContainer as PackageDetailsContainer,
  IPackageDetailsContainerRouteParams,
};
